const state = {
  applicationSummary: undefined,
  latestLoanId: undefined,
  supportId: undefined,
  welcomeRewardsData: undefined,
  isBusinessRegistrationDocUploaded: undefined,
  isBankStatementDocUploaded: undefined,
  applicationProfileData: undefined,
  legalLanguage: JSON.parse(localStorage.getItem("legalLanguage")) || "english",
  nbfcName: JSON.parse(localStorage.getItem("nbfcName")) || "",
};
export default state;
